/**
 * Transaction format constants for Ethereum and EVM-compatible chains
 * Using const assertions for zero runtime overhead
 *
 * These constants are stable and follow official EIP specifications:
 * - Legacy: Original Ethereum transaction format (Type 0)
 * - EIP-2930: Access List transactions (Type 1)
 * - EIP-1559: Fee Market transactions (Type 2)
 * - EIP-712: Structured data signing for meta-transactions
 */
export const TRANSACTION_FORMATS = {
    LEGACY: 'legacy',
    EIP_2930: 'EIP-2930',
    EIP_1559: 'EIP-1559',
    EIP_712: 'EIP-712'
};
/**
 * Human-readable descriptions for API documentation and error messages
 * Maps format values to clear descriptions
 */
export const TRANSACTION_FORMAT_DESCRIPTIONS = {
    [TRANSACTION_FORMATS.LEGACY]: 'Legacy Ethereum transaction (Type 0) with gasPrice',
    [TRANSACTION_FORMATS.EIP_2930]: 'EIP-2930 Access List transaction (Type 1) with gasPrice and accessList',
    [TRANSACTION_FORMATS.EIP_1559]: 'EIP-1559 Fee Market transaction (Type 2) with maxFeePerGas and maxPriorityFeePerGas',
    [TRANSACTION_FORMATS.EIP_712]: 'EIP-712 structured data for smart wallet meta-transactions'
};
